<template>
  <Catalogs
    title="Категории занятости"
    create-text="Новая"
    :fetch-data="fetchData"
    :fields="fields"
    :route-create="'EmploymentCategoryAdd'"
    :route-edit="'EmploymentCategoryEdit'"
    :route-view="'EmploymentCategoryView'"
    :route-path="'/employment_categories'"
    :can-edit="canEditEmploymentCategoryCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
import permissions, {PERM} from "../../../utilites/permissions";
import Catalogs from "../Catalogs.vue";

export default {
  name: "EmploymentCategories",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  data() {
    return {
      fields: [
        {
          key: 'id',
          sortable: false,
          class: 'employment-category-id'
        },
        {
          key: 'name',
          label: "Название",
          sortable: false,
        },
        {
          key: 'active',
          label: "Активный",
          sortable: false,
        },
        {
          key: 'action',
          label: "Действия",
          class: 'employment-category-action'
        },
      ],
    }
  },
  methods: {
    async fetchData(data) {
      return await this.getEmploymentCategories(data);
    },
    canEditEmploymentCategoryCatalogs() {
      return this.hasPermission([PERM.CATALOG_DEPARTMENT_EDIT]);
    }
  }
}
</script>

<style>
.employment-category-id {
  padding-left: 10px !important;
  width: 60px;
  text-align: center;
}

.employment-category-action {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/EmploymentCategories/EmploymentCategories.vue